// import React, { useState, useEffect } from "react";
// import { Input, Button } from "../../styled-components";
// import styled from "styled-components";

// const Container = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   flex-direction: cloumn;

//   button {
//     width: 10px;
//   }

//   .input-container {
//     width: 300px;
//   }

//   @media screen and (max-width: 768px) {
//     .btn-txt {
//       display: none;
//     }
//   }
// `;
// const SearchBar = ({
//   filterOn,
//   setFilterOn,
//   setText,
//   filter,
//   setFilter,
//   setPageNumber,
//   totalPage
// }) => {
//   const initialState = {
//     search: ""
//   };

//   const [searchs, setSearch] = useState(initialState);
//   const handleChange = event => {
//     const { name, value } = event.target;

//     setSearch({ ...searchs, [name]: value });
//     setText(event.target.value);
//   };
//   const updateState = () => {
//     if (searchs.search.length > 0) {
//       setFilter(!filter);
//       setPageNumber(totalPage);
//     }
//   };
//   return (
//     <Container>
//       <div className="input-container">
//         <Input
//           label="Search"
//           name="search"
//           value={searchs.search}
//           type="text"
//           onChange={handleChange}
//         />
//       </div>
//       <Button type="button" onClick={() => updateState()}>
//         <span className="btn-txt"></span>
//         <i className="fas fa-search" />
//       </Button>
//     </Container>
//   );
// };

// export default SearchBar;

import React, { useState, useEffect } from "react";
import { Input, Button } from "../../styled-components";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  button {
    width: 10px;
  }

  .input-container {
    width: 300px;
  }

  @media screen and (max-width: 768px) {
    .btn-txt {
      display: none;
    }
  }
`;

const SearchBar = ({ setText, setPageNumber }) => {
  const [searchInput, setSearchInput] = useState("");
  const debounceDelay = 300;

  // Debounce logic
  useEffect(() => {
    const handler = setTimeout(() => {
      setText(searchInput);
      setPageNumber(0);
    }, debounceDelay);

    return () => {
      clearTimeout(handler);
    };
  }, [searchInput, setText, setPageNumber]);

  const handleChange = event => {
    setSearchInput(event.target.value);
  };

  const handleSearchClick = () => {
    if (searchInput.trim() !== "") {
      setText(searchInput);
      setPageNumber(0);
    }
  };
  

  return (
    <Container>
      <div className="input-container">
        <Input
          label="Search"
          name="search"
          value={searchInput}
          type="text"
          onChange={handleChange}
        />
      </div>
      <Button type="button" onClick={handleSearchClick}>
        <span className="btn-txt"></span>
        <i className="fas fa-search" />
      </Button>
    </Container>
  );
};

export default SearchBar;
